enum ActionType {
  TOGGLE_HELP_DRAWER = 'TOGGLE_HELP_DRAWER',
  OPEN_HELP_DRAWER = 'OPEN_HELP_DRAWER',
  CLOSE_HELP_DRAWER = 'CLOSE_HELP_DRAWER',
}

type State = {
  open: boolean
}

export const toggleHelpDrawer = () => ({
  type: ActionType.TOGGLE_HELP_DRAWER,
})

export const openHelpDrawer = () => ({
  type: ActionType.OPEN_HELP_DRAWER,
})

export const closeHelpDrawer = () => ({
  type: ActionType.CLOSE_HELP_DRAWER,
})

export const reducer = (
  state: State = {
    open: false,
  },
  action: any
): State => {
  switch (action.type) {
    case ActionType.TOGGLE_HELP_DRAWER: {
      return {
        ...state,
        open: !state.open,
      }
    }
    case ActionType.OPEN_HELP_DRAWER: {
      return {
        ...state,
        open: true,
      }
    }
    case ActionType.CLOSE_HELP_DRAWER: {
      return {
        ...state,
        open: false,
      }
    }
    default:
      return state
  }
}
